import { ToolTabsTitles } from '../constants';
import { TOOLS_ROUTES } from './constants';
import LocalAuth from '@shamrock-core/common/authentication/local-authentication';

const TOOL_PERMISSIONS = {
  [ToolTabsTitles.MassInvite]: ['carrierpro.ViewUserManagementTools'],
  [ToolTabsTitles.MergeCompanies]: ['carrierpro.ViewUserManagementTools'],
  [ToolTabsTitles.DeviceLimitsWhiteList]: ['internal.Admintools.User'],
  [ToolTabsTitles.PasswordUpdates]: ['carrierpro.RepCompanyAdmin'],
  [ToolTabsTitles.Underwriting]: ['internal.SearchIp'],
  [ToolTabsTitles.SubscriptionManagement]: ['carrierpro.SubscriptionsManagement'],
  [ToolTabsTitles.PTCompanyReset]: ['tms.internaladmin.companyreset'],
};

const TITLE_TO_ROUTE = {
  [ToolTabsTitles.MassInvite]: TOOLS_ROUTES.BulkInvite,
  [ToolTabsTitles.MergeCompanies]: TOOLS_ROUTES.MergeCompanies,
  [ToolTabsTitles.DeviceLimitsWhiteList]: TOOLS_ROUTES.DeviceLimitsWhiteList,
  [ToolTabsTitles.PasswordUpdates]: TOOLS_ROUTES.PasswordUpdates,
  [ToolTabsTitles.Underwriting]: TOOLS_ROUTES.Underwriting,
  [ToolTabsTitles.SubscriptionManagement]: TOOLS_ROUTES.SubscriptionManagement,
  [ToolTabsTitles.PTCompanyReset]: TOOLS_ROUTES.PTCompanyReset,
};

export const checkIfInternalUser = (subNavList: { title: string; path: string }[], userPermissions: string[]) => {
  const isInternalUser = userPermissions.includes('internal.Admintools.User');
  return !isInternalUser
    ? subNavList.filter((item) => item.title !== ToolTabsTitles.DeviceLimitsWhiteList)
    : subNavList;
};

export const filterSubNavByPermissions = (
  subNavList: { title: string; path: string }[],
  userPermissions: string[],
): { title: string; path: string }[] => {
  return subNavList.filter((item) => {
    const requiredPermissions = TOOL_PERMISSIONS[item.title as keyof typeof TOOL_PERMISSIONS];
    if (!requiredPermissions || requiredPermissions.length === 0) {
      return true;
    }

    return requiredPermissions.every((permission) => userPermissions.includes(permission));
  });
};

export const getFirstAvailableRoute = (
  subNavList: { title: string; path: string }[],
  userPermissions: string[],
): string => {
  const filteredSubNav = filterSubNavByPermissions(subNavList, userPermissions);

  if (filteredSubNav.length > 0) {
    const firstTitle = filteredSubNav[0].title as keyof typeof TITLE_TO_ROUTE;
    return TITLE_TO_ROUTE[firstTitle] || TOOLS_ROUTES.BulkInvite;
  }

  return TOOLS_ROUTES.BulkInvite;
};

export const getCompanyId = async (): Promise<string | null> => {
  const company = window.localStorage.getItem(LocalAuth.COMPANY_KEY);
  if (company) {
    const json = JSON.parse(company);
    return json.company_id;
  }
  return null;
};
